<template>
<div id="app" class="app">
  <gi-nav :menu="data['导航栏']" :logo="data['logo']"></gi-nav>
  <div class="bgcolor"></div>
  <img class="bgimg" src="https://static001.geekbang.org/resource/image/51/8c/51eed7ab3beafebd660c4086224d0a8c.png" alt="">
  <img class="bgimg-mobile" src="https://static001.geekbang.org/resource/image/6f/86/6f56cd0477265c446a6856bce5383586.png" alt="">  
  <div class="helper">
    <img class="helper-icon" src="https://static001.geekbang.org/resource/image/15/11/15f83de8245fc8c978e4cef899cabc11.png" alt="">
    <img class="qrcode" src="https://static001.geekbang.org/resource/image/0b/c3/0b732aeaf2e8a849c97b0ee8062782c3.jpeg" alt="">
    <span>大赛小助手</span>
  </div>
  <a href="#helper-mobile-target" class="helper-mobile">大赛小助手</a>
  <div class="nav-container" v-bind:class=" navBarFixed ? 'navbar-bg' : ''">
    <div class="nav">
      <img class="logo" src="https://static001.geekbang.org/resource/image/66/2e/6683c714fbc4b84b5524dd2b9efc572e.png" alt="">
      <ul class="nav-list">
        <li
          v-for="(item, index) in data.nav"
          :key="index"
          v-bind:class="navtab === index && navtab !== data.nav.length ? 'active' : '' "
          @mouseover="navHover( index)" >
          <a :href="item.link">{{item.text}}</a>
        </li>
        <li @mouseover="navDocHoverFn" @mouseout="navDocOutFn" v-bind:class="docsHover ? 'navDocHoverClass' : ''">
          <a href="https://github.com/FISCO-BCOS/FISCO-BCOS/wiki" target="_blank">技术文档</a>
        </li>
      </ul>
    </div>
  </div>
  <!-- video -->
  <div class="" :class="modalShow ? 'videoBox' : 'boxHide'">
    <video 
      class="videoContent video-js vjs-default-skin" ref="pcvideo" 
      id="pcvideo" 
      autoplay="true"
      controls
      preload="auto"
      webkit-playsinline="true"
      playsinline="true"
      x-webkit-airplay="allow"
      x5-video-player-type="h5"
      x5-video-orientation="landscape"
    >
      <source src="https://media001.geekbang.org/48c33e6607a34d618042e4e36cd1c466/0a9e516a58ce41559c9b6dcd6d636274-58afd1d9a9cf923aa47628960fad5f9b-sd.m3u8" type="application/x-mpegURL">
    </video>
    <img 
      class="closeBtn"
      @click="closeModal"
      src="https://static001-test.geekbang.org/resource/image/e2/06/e28226c70aaa7c2789f14f7941f25b06.png" alt="">
  </div>
  <div class="container">
    <div class="content">
      <!-- head -->
      <div class="head">
        <img src="https://static001.geekbang.org/resource/image/65/42/6526a3e4249c41f4f215bb2591bafd42.png" alt="">
        <h1 class="h1">金链盟中国区块链应用大赛</h1>
        <h2 class="en">FISCO BCOS Blockchain Application Contest (China)</h2>
        <div class="slogan">盟 &nbsp九 &nbsp 州&nbsp · &nbsp链 &nbsp未 &nbsp来</div>
      </div>
      <div class="learmore2 btnHover" @click="videoPlay">
        <img class="playicon" src="https://static001.geekbang.org/resource/image/6f/19/6f482bcb9bbc4aea2f23eba054f69c19.png" alt="">
        <span>团队风采展示</span>
      </div>
      <!-- loop -->
      <div id="intro-title" class="block-title" style="margin-top: 60px;">
        <img src="https://static001.geekbang.org/resource/image/72/86/721cac1e31cc87a02fe9963345c50286.png" alt="">
        <span>精彩瞬间</span>
        <img src="https://static001.geekbang.org/resource/image/75/97/7504f4738db767caa71a1f43a6bc8797.png" alt="">
      </div>
      <div>
        <subloop></subloop>
      </div>
      
      <!-- 奖项-->
      <div class="top10box" style="margin-top: 0;">
        <!-- 特等奖 -->
        <div class="topBox">
          <span class="line"></span>
          <span class="text">特等奖</span>
          <span class="line"></span>
        </div>
        <div class="lineOne">
          <div class="oneBox">
            <div class="team-cover" :style="{'backgroundImage': `url(${top10.TOP.cover})`}"></div>
            <div class="team-content">
              <div class="team-content-inner">
                <div class="team-name">{{top10.TOP.project}}</div>
                <div class="team-intro">{{top10.TOP.content}}</div>
                <div class="team-from">{{top10.TOP.name}}</div>
              </div>
            </div>
          </div>
        </div>
        <!-- 一等奖 -->
        <div class="topBox">
          <span class="line"></span>
          <span class="text">一等奖</span>
          <span class="line"></span>
        </div>
        <div class="lineOne">
          <div class="oneBox">
            <div class="team-cover" :style="{'backgroundImage': `url(${top10.ONE.cover})`}"></div>
            <div class="team-content">
              <div class="team-content-inner">
                <div class="team-name">{{top10.ONE.project}}</div>
                <div class="team-intro">{{top10.ONE.content}}</div>
                <div class="team-from">{{top10.ONE.name}}</div>
              </div>
            </div>
          </div>
        </div>
        <!-- 二等奖 -->
        <div class="topBox">
          <span class="line"></span>
          <span class="text">二等奖</span>
          <span class="line"></span>
        </div>
        <div class="lineOne">
          <div class="oneBox">
            <div class="team-cover" :style="{'backgroundImage': `url(${top10.TWO.cover})`}"></div>
            <div class="team-content">
              <div class="team-content-inner">
                <div class="team-name">{{top10.TWO.project}}</div>
                <div class="team-intro">{{top10.TWO.content}}</div>
                <div class="team-from">{{top10.TWO.name}}</div>
              </div>
            </div>
          </div>
        </div>
        <!-- 三等奖 -->
        <div class="topBox">
          <span class="line"></span>
          <span class="text">三等奖</span>
          <span class="line"></span>
        </div>
        <div class="top10-pc">
          <div class="items" v-for="(item, index) in top10.THREE" :key="index">
            <div class="itemsBox">
              <div class="team-cover" :style="{'backgroundImage': `url(${item.cover})`}"></div>
              <div class="team-content">
                <div class="team-content-inner">
                  <div class="team-name">{{item.project}}</div>
                  <div class="team-intro">{{item.content}}</div>
                  <div class="team-from">{{item.name}}</div>
                </div>
              </div>
            </div>
          </div>
        </div>
        <!-- 特殊奖 -->
        <div class="top10-pc">
          <div class="items" v-for="(item, index) in top10.subAward" :key="index">
            <div class="topBox">
              <span class="line"></span>
              <span class="text">{{item.awardName}}</span>
              <span class="line"></span>
            </div>
            <div class="itemsBox itemsBoxFix">
              <div class="team-cover" :style="{'backgroundImage': `url(${item.cover})`}"></div>
              <div class="team-content">
                <div class="team-content-inner">
                  <div class="team-name">{{item.project}}</div>
                  <div class="team-intro">{{item.content}}</div>
                  <div class="team-from">{{item.name}}</div>
                </div>
              </div>
            </div>
          </div>
        </div>
      </div>
      <!-- <div class="block-line">
        <div class="block-line-left"></div>
        <img src="https://static001.geekbang.org/resource/image/f4/23/f4101ff41e7c0a04123bd7c2fc6c3823.png" alt="">
        <div class="block-line-right"></div>
      </div> -->
      <!-- intro -->
      <div class="inro">
        <div id="intro-title" class="block-title">
          <img src="https://static001.geekbang.org/resource/image/72/86/721cac1e31cc87a02fe9963345c50286.png" alt="">
          <span>大赛介绍</span>
          <img src="https://static001.geekbang.org/resource/image/75/97/7504f4738db767caa71a1f43a6bc8797.png" alt="">
        </div>
        <div class="text-area">
          <p>金链盟中国区块链应用大赛（FISCO BCOS Blockchain Application Contest (China)）由中国电子技术标准化研究院、中国计算机学会等单位指导；中钞区块链技术研究院为学术指导单位；金链盟、 深圳市金融科技协会等单位主办；微众银行赞助；腾讯云协办；极客邦 & InfoQ 为战略合作伙伴。</p>
          <p>本次大赛致力于在全国范围内征集企事业单位、科研机构、项目团队、开发者队伍使用FISCO BCOS底层平台进行开发的优秀实践，评选出2018年度最佳应用案例，促进区块链技术的商业转化，同时扶持合作单位及科研机构、初创企业、开发者队伍落地更多基于FISCO BCOS底层平台的优秀应用。</p>
          <p>本次大赛分为初赛、复赛、决赛三个阶段，赛题涉及金融、公益、医疗、教育、供应链、版权、司法等领域。我们也为此次大赛组成了阵容豪华的专家评审团，为参赛者提供专业指导，并本着公开、公正、公平的原则，评选出最优秀的作品和最优秀的人才。</p>
          <p style="margin-bottom: 0;">大赛总奖金池超过200万，其中设立特等奖1名（奖金100万），一等奖1名（奖金50万），二等奖1名（奖金30万），三等奖7名（奖金各5万），欢迎优秀团队报名参赛。</p>
        </div>
      </div>
      <div class="block-line">
        <div class="block-line-left"></div>
        <img src="https://static001.geekbang.org/resource/image/f4/23/f4101ff41e7c0a04123bd7c2fc6c3823.png" alt="">
        <div class="block-line-right"></div>
      </div>
      <!-- 赛事动态 -->
      <div id="status" class="status">
        <div class="block-title">
          <img src="https://static001.geekbang.org/resource/image/72/86/721cac1e31cc87a02fe9963345c50286.png" alt="">
          <span>赛事动态</span>
          <img src="https://static001.geekbang.org/resource/image/75/97/7504f4738db767caa71a1f43a6bc8797.png" alt="">
        </div>
        <!-- | 文章1 -->
        <div class="info" style="margin-bottom: 31px;">
          <img class="poster" src="https://static001.geekbang.org/resource/image/54/c1/54a676baa16d889378cf2308e9e569c1.png" alt="">
          <div class="infos">
            <div class="timer">2018-08-28</div>
            <h2 class="title"><a href="https://github.com/FISCO-BCOS/Wiki/tree/master/FISCO%20BCOS%E5%AE%9E%E8%B7%B5%E6%8C%87%E5%BC%95" target="_blank">FISCO BCOS 实践指引</a></h2>
            <p class="infos-text">本文作为一个概括性的实践指引, 包含了 FISCO BCOS 的环境搭建、特性简介、业务实践的介绍预览, 可以使开发者对 FISCO BCOS 有一个全局性的认识, 更完整信息可以参考 <a href="https://github.com/FISCO-BCOS/Wiki" target="_blank">Wiki</a> 。</p>
          </div>
        </div>
        <!-- | 文章2 -->
        <div class="info">
          <img class="poster" src="https://static001.geekbang.org/resource/image/d4/5c/d46bfbc4d74af62e1f4db659a9ccd65c.png" alt="">
          <div class="infos">
            <div class="timer">2018-08</div>
            <h2 class="title"><a href="https://www.fisco.com.cn/views/situationNews.html?newsId=201809181537254405" target="_blank">FISCO BCOS应用案例精编 2018.08</a></h2>
            <p class="infos-text">从场景解决方案的维度，介绍区块链优势、区块链解决方案，及目前落地的实践案例。</p>
          </div>
        </div>
        <!-- <div class="learmore"><a href="">查看更多</a></div> -->
        <div class="learmore btnHover">
          <div class="hoverbox"></div>
          <a href="https://www.fisco.com.cn/views/situation.html" target="_blank">查看更多</a></div>
      </div>
      <div class="block-line">
        <div class="block-line-left"></div>
        <img src="https://static001.geekbang.org/resource/image/f4/23/f4101ff41e7c0a04123bd7c2fc6c3823.png" alt="">
        <div class="block-line-right"></div>
      </div>
      <!-- 参赛权益 -->
      <div id="rights" class="rights">
        <div class="block-title">
          <img src="https://static001.geekbang.org/resource/image/72/86/721cac1e31cc87a02fe9963345c50286.png" alt="">
          <span>参赛权益</span>
          <img src="https://static001.geekbang.org/resource/image/75/97/7504f4738db767caa71a1f43a6bc8797.png" alt="">
        </div>
        <div class="rights-block">
          <div class="rights-list-box">
            <div class="rights-list">
              <span class="right-item">两百万奖金池</span>
              <div class="bg"></div>
              <div class="right-bottom-hover"></div>
            </div>
            <span class="rights-list-text">超过200万的现金奖励</span>
          </div>
          <div class="rights-list-box">
            <div class="rights-list">
              <span class="right-item">项目孵化</span>
              <div class="bg"></div>
              <div class="right-bottom-hover"></div>
            </div>
            <span class="rights-list-text">优秀项目可获得创投机会</span>
          </div>
          <div class="rights-list-box">
            <div class="rights-list">
              <span class="right-item">千万曝光</span>
              <div class="bg"></div>
              <div class="right-bottom-hover"></div>
            </div>
            <span class="rights-list-text">金链盟品牌、渠道+百家媒体曝光</span>
          </div>
          <div class="rights-list-box">
            <div class="rights-list">
              <span class="right-item">开发者助力</span>
              <div class="bg"></div>
              <div class="right-bottom-hover"></div>
            </div>
            <span class="rights-list-text">FISCO BCOS 底层平台技术一对一指导</span>
          </div>
        </div>
      </div>
      <div class="block-line">
        <div class="block-line-left"></div>
        <img src="https://static001.geekbang.org/resource/image/f4/23/f4101ff41e7c0a04123bd7c2fc6c3823.png" alt="">
        <div class="block-line-right"></div>
      </div>
      <!-- 大赛奖项 -->
      <div id="awards" class="awards">
        <div class="block-title">
          <img src="https://static001.geekbang.org/resource/image/72/86/721cac1e31cc87a02fe9963345c50286.png" alt="">
          <span>大赛奖项</span>
          <img src="https://static001.geekbang.org/resource/image/75/97/7504f4738db767caa71a1f43a6bc8797.png" alt="">
        </div>
        <div class="awards-block">
          <div class="awards-list-box">
            <div class="awards-list">
              <span>奖金</span>
              <span>100万</span>
            </div>
            <span class="awards-list-text">特等奖1名</span>
          </div>
          <div class="awards-list-box">
            <div class="awards-list">
              <span>奖金</span>
              <span>50万</span>
            </div>
            <span class="awards-list-text">一等奖1名</span>
          </div>
          <div class="awards-list-box">
            <div class="awards-list">
              <span>奖金</span>
              <span>30万</span>
            </div>
            <span class="awards-list-text">二等奖1名</span>
          </div>
          <div class="awards-list-box">
            <div class="awards-list">
              <span>奖金</span>
              <span>5万</span>
            </div>
            <span class="awards-list-text">三等奖7名</span>
          </div>
        </div>
      </div>
      <div class="block-line">
        <div class="block-line-left"></div>
        <img src="https://static001.geekbang.org/resource/image/f4/23/f4101ff41e7c0a04123bd7c2fc6c3823.png" alt="">
        <div class="block-line-right"></div>
      </div>
      <!-- 赛题范围 -->
      <div class="range">
        <div class="block-title range-title">
          <img src="https://static001.geekbang.org/resource/image/72/86/721cac1e31cc87a02fe9963345c50286.png" alt="">
          <span>赛题范围</span>
          <img src="https://static001.geekbang.org/resource/image/75/97/7504f4738db767caa71a1f43a6bc8797.png" alt="">
        </div>
        <div class="range-block">
          <div class="range-list">
            <div class="range-1 bg-all">
              <div class="float-top-1 ft-normal"></div>
              <!-- <img class="red-ball" src="https://static001.geekbang.org/resource/image/80/bb/80d981ea4693bbba164bb163c077c1bb.png" alt=""> -->
            </div>
            <span>金融</span>
          </div>
          <div class="range-list">
            <div class="range-2 bg-all">
              <div class="float-top-2 ft-normal"></div>
            </div>
            <span>公益</span>
          </div>
          <div class="range-list">
            <div class="range-3 bg-all">
              <div class="float-top-3 ft-normal"></div>
            </div>
            <span>医疗</span>
          </div>
          <div class="range-list">
            <div class="range-4 bg-all">
              <div class="float-top-4 ft-normal"></div>
            </div>
            <span>教育</span>
          </div>
          <div class="range-list">
            <div class="range-5 bg-all">
              <div class="float-top-5 ft-normal"></div>
            </div>
            <span>供应链</span>
          </div>
          <div class="range-list">
            <div class="range-6 bg-all">
              <div class="float-top-6 ft-normal"></div>
            </div>
            <span>商品溯源</span>
          </div>
          <div class="range-list">
            <div class="range-7 bg-all">
              <div class="float-top-7 ft-normal"></div>
            </div>
            <span>版权</span>
          </div>
          <div class="range-list">
            <div class="range-8 bg-all">
              <div class="float-top-8 ft-normal"></div>
            </div>
            <span>司法</span>
          </div>
          <div class="range-list">
            <div class="range-9 bg-all">
              <div class="float-top-9 ft-normal"></div>
            </div>
            <span>交通</span>
          </div>
          <div class="range-list">
            <div class="range-10 bg-all">
              <div class="float-top-10 ft-normal"></div>
            </div>
            <span>社交</span>
          </div>
        </div>
      </div>
      <div class="block-line">
        <div class="block-line-left"></div>
        <img src="https://static001.geekbang.org/resource/image/f4/23/f4101ff41e7c0a04123bd7c2fc6c3823.png" alt="">
        <div class="block-line-right"></div>
      </div>
      <!-- 专家评委 -->
      <div id="judge" class="judge">
        <div class="block-title judge-title">
          <img src="https://static001.geekbang.org/resource/image/72/86/721cac1e31cc87a02fe9963345c50286.png" alt="">
          <span>专家评委</span>
          <img src="https://static001.geekbang.org/resource/image/75/97/7504f4738db767caa71a1f43a6bc8797.png" alt="">
        </div>
        <div class="pwei-block">
          <div class="pwei-list"
            v-for="(item, index) in data.judge"
            :key="index"
            @mouseover="judgeHover(index)"
            @mouseout="judgeOut()"
            v-bind:class="judgeShow === index ? 'box-hover' : ''"
            >
            <div class="pwei-head" :style="{'backgroundImage': `url(${item.avatar})`}"></div>
            <div class="pwei-shadow" v-bind:class="judgeShow === index ? 'shadow-hover' : ''">
              <div class="name">{{item.name}}</div>
              <div class="tag" v-for="(tag, i) in item.tags" :key="i">{{tag}}</div>
            </div>
          </div>
        </div>
        <div style="margin-top: 40px;text-align: center;font-size: 16px;">注：按照嘉宾姓氏首字母排序</div>  
      </div>
      <div class="block-line">
        <div class="block-line-left"></div>
        <img src="https://static001.geekbang.org/resource/image/f4/23/f4101ff41e7c0a04123bd7c2fc6c3823.png" alt="">
        <div class="block-line-right"></div>
      </div>
      <!-- 赛程安排 -->
      <div id="schedule" class="schedule">
        <div class="block-title">
          <img src="https://static001.geekbang.org/resource/image/72/86/721cac1e31cc87a02fe9963345c50286.png" alt="">
          <span>赛程安排</span>
          <img src="https://static001.geekbang.org/resource/image/75/97/7504f4738db767caa71a1f43a6bc8797.png" alt="">
        </div>
        <div class="schedule-pc">
          <div class="schedule-jd">
            <span>大赛报名启动</span>
            <span>初赛作品提交开启</span>
            <span>初赛作品提交截止</span>
            <span>初赛入围结果公布<br>开启点赞投票</span>
            <span>复赛入围结果公布</span>
            <span>总决赛峰会（深圳）</span>
          </div>
          <div class="schedule-line">
            <span>|</span>
            <span>|</span>
            <span>|</span>
            <span>|</span>
            <span>|</span>
            <span>|</span>
          </div>
          <div class="progress-box">
            <div class="progress">
              <div class="progress-inner">&nbsp</div>
            </div>
          </div>
          <div class="schedule-time">
            <span>8月28日</span>
            <span>9月19日</span>
            <span>11月10日</span>
            <span>11月15日</span>
            <span>12月15日</span>
            <span>12月21日</span>
          </div>
          <div class="schedule-intro">
            <div class="intro-list now">
              <div class="intro-list-text">
                <span>大赛报名</span>
                <span>项目材料提交</span>
              </div>
              <span class="range-timer">8.28-11.10</span></div>
            <div class="intro-list now">
              <div class="intro-list-text">
                <span>作品提交</span>
              </div>
              <span class="range-timer">9.19-11.10</span></div>
            <div class="intro-list now" >
              <div class="intro-list-text">
                <span>初赛入围评审</span>
              </div>
              <span class="range-timer">11.10-11.15</span></div>
            <div class="intro-list now" >
              <div class="intro-list-text">
                <span>复赛入围评审</span>
                <span></span>
              </div>
              <span class="range-timer">11.15-12.15</span></div>
            <div class="intro-list now">
              <div class="intro-list-text">
                <span>复赛团队</span>
                <span>及项目沟通</span>
              </div>
              <span class="range-timer">12.15-12.21</span></div>
          </div>
        </div>
        <div class="schedule-mobile">
          <div class="schedule-mobile-inner">
            <div class="timer">
              <div class="kedu-l">
                <span>8月28日</span><span>-</span></div>
              <div class="kedu-l">
                <span>9月19日</span><span>-</span></div>
              <div class="kedu-l">
                <span>11月10日</span><span>-</span></div>
              <div class="kedu-l">
                <span>11月15日</span><span>-</span></div>
              <div class="kedu-l">
                <span>12月15日</span><span>-</span></div>
              <div class="kedu-l">
                <span>12月21日</span><span>-</span></div>
            </div>
            <div class="pregress">
              <div class="pregress-inner"></div>
            </div>
            <div class="desc">
              <div class="desc-list">
                <div class="kedu-r">- 大赛报名启动</div>
                <div class="info-box now">
                  <span>大赛报名项目材料提交</span>
                  <span>(8.28-11.10)</span>
                </div>
              </div>
              <div class="desc-list">
                <div class="kedu-r">- 初赛作品提交开启</div>
                <div class="info-box now">
                  <span>作品提交</span>
                  <span>(9.19-11.10)</span>
                </div>
              </div>
              <div class="desc-list">
                <div class="kedu-r">- 初赛作品提交截止</div>
                <div class="info-box now">
                  <span>初赛入围评审</span>
                  <span>11.10-11.15)</span>
                </div>
              </div>
              <div class="desc-list">
                <div class="kedu-r">- 初赛入围结果公布，开启点赞投票</div>
                <div class="info-box now">
                  <span>复赛入围评审</span>
                  <span>(11.15-12月15日)</span>
                </div>
              </div>
              <div class="desc-list">
                <div class="kedu-r">- 复赛入围结果公布</div>
                <div class="info-box now">
                  <span>复赛团队及项目沟通</span>
                  <span>(12月15日-12月21日)</span>
                </div>
              </div>
              <div class="desc-list">
                <div class="kedu-r">- 总决赛峰会（深圳）</div>
              </div>
            </div>
          </div>
        </div>
      </div>
      <div class="block-line">
        <div class="block-line-left"></div>
        <img src="https://static001.geekbang.org/resource/image/f4/23/f4101ff41e7c0a04123bd7c2fc6c3823.png" alt="">
        <div class="block-line-right"></div>
      </div>
      <!-- 评审规则 -->
      <div id="rulers" class="rulers">
        <div class="block-title">
          <img src="https://static001.geekbang.org/resource/image/72/86/721cac1e31cc87a02fe9963345c50286.png" alt="">
          <span>评审规则</span>
          <img src="https://static001.geekbang.org/resource/image/75/97/7504f4738db767caa71a1f43a6bc8797.png" alt="">
        </div>
        <div class="rulers-block">
          <div class="rulers-list" @mouseover="overshow(1)" @click="overshow(1)">
            <div class="ruler-icon" v-bind:class="showTab === 1 ? 'ruler-icon-hover' : ''">
              <img src="https://static001.geekbang.org/resource/image/78/f5/78794694dabbdb244a192c52685909f5.png" alt="">
            </div>
            <span>技术先进性</span>
          </div>
          <div class="rulers-list" @mouseover="overshow(2)" @click="overshow(2)">
            <div class="ruler-icon" v-bind:class="showTab === 2 ? 'ruler-icon-hover' : ''">
              <img src="https://static001.geekbang.org/resource/image/7e/3d/7e903b38f89e7b8e33b42fe3cdaea43d.png" alt="">
            </div>
            <span>商业价值</span>
          </div>
          <div class="rulers-list" @mouseover="overshow(3)" @click="overshow(3)">
            <div class="ruler-icon" v-bind:class="showTab === 3 ? 'ruler-icon-hover' : ''">
              <img src="https://static001.geekbang.org/resource/image/18/99/181589cfb545b38455ee7e624253fe99.png" alt="">
            </div>
            <span>产品设计</span>
          </div>
          <div class="rulers-list" @mouseover="overshow(4)" @click="overshow(4)">
            <div class="ruler-icon" v-bind:class="showTab === 4 ? 'ruler-icon-hover' : ''">
              <img src="https://static001.geekbang.org/resource/image/04/25/0448e72b2158e490898021b4771ae125.png" alt="">
            </div>
            <span>方案完整性</span>
          </div>
        </div>
        <div class="rulers-border-bottom">
          <span v-bind:class="showTab === 1 ? 'ruler-hover' : '' "></span>
          <span v-bind:class="showTab === 2 ? 'ruler-hover' : '' "></span>
          <span v-bind:class="showTab === 3 ? 'ruler-hover' : '' "></span>
          <span v-bind:class="showTab === 4 ? 'ruler-hover' : '' "></span>
        </div>
        <ul class="rulers-texts">
          <li v-if="showTab === 1">架构设计和代码编写合理、功能完善、运行稳定、可靠安全，自主可控，高效可用。</li>
          <li v-if="showTab === 2">具备较好商业价值，可以解决当前行业痛点，且该作品可以充分体现区块链技术的价值与优势。</li>
          <li v-if="showTab === 3">与行业成熟方案相比，有更多创意和创新，用户体验出色，有更好的产品表现。</li>
          <li v-if="showTab === 4">具备完善的技术说明文档与演示文档，能覆盖用户，商业，运营运维等完整的场景。</li>
        </ul>
      </div>
      <div class="block-line">
        <div class="block-line-left"></div>
        <img src="https://static001.geekbang.org/resource/image/f4/23/f4101ff41e7c0a04123bd7c2fc6c3823.png" alt="">
        <div class="block-line-right"></div>
      </div>
      <!-- 参赛须知 -->
      <div id="notify" class="notify">
        <div class="block-title">
          <img src="https://static001.geekbang.org/resource/image/72/86/721cac1e31cc87a02fe9963345c50286.png" alt="">
          <span>参赛须知</span>
          <img src="https://static001.geekbang.org/resource/image/75/97/7504f4738db767caa71a1f43a6bc8797.png" alt="">
        </div>
        <div class="notify-infos">
          <p>1、以企事业单位、科研机构、项目团队、开发者队伍为主体报名参加；同一组织可报多个应用项目参加大赛；</p>
          <p>2、违反央行等七部委于2017年9月4日发布《关于防范代币发行融资风险的公告》的团队将随时被取消比赛资格；</p>
          <p>3、参赛团队需独立完成作品，无任何作弊、欺诈、侵犯他人知识产权行为，如有违反，取消参赛资格和比赛成绩；</p>
          <p>4、每个参赛项目需提交参赛作品的介绍材料、技术成果和应用效果，完成度较高或者生产案例可获得加分；</p>
          <p>5、已经在国内其他大赛得奖的案例不参与评选；</p>
          <p>6、参赛项目需要根据比赛流程和参赛须知，在线完成比赛报名和作品提交工作，组委会可根据比赛需要，通过官方渠道要求团队补充相关个人信息；</p>
          <p>7、参赛作品截止报名前，参赛队伍可对参赛作品进行完善，但不能更改作品主题，最终参赛作品以截止报名前提交的最后版本为准；</p>
          <p>8、本次大赛参赛作品的知识产权归参赛团队所有，主办方有权将参赛作品、作品相关、参赛团队信息用于宣传品、相关出版物、指定及授权媒体发布、官方网站浏览及下载、展览（含巡展）；</p>
          <p>9、参赛作品必须基于 FISCO BCOS 底层平台进行开发；</p>
          <p>10、大赛评委方成员不得报名参赛；</p>
          <p style="margin-bottom: 0;">11、代码质量是评审点之一，需要提交部分区块链技术相关源码，主要包括业务脱敏后的智能合约代码、客户端和区块链相关的代码。可不包含业务核心逻辑部分代码，前端交互代码等，这些部分作为可执行程序进行演示。</p>
        </div>
      </div>
      <div class="block-line">
        <div class="block-line-left"></div>
        <img src="https://static001.geekbang.org/resource/image/f4/23/f4101ff41e7c0a04123bd7c2fc6c3823.png" alt="">
        <div class="block-line-right"></div>
      </div>
      <!-- 合作单位 -->
      <div id="partner" class="partner">
        <div class="block-title">
          <img src="https://static001.geekbang.org/resource/image/72/86/721cac1e31cc87a02fe9963345c50286.png" alt="">
          <span>合作单位</span>
          <img src="https://static001.geekbang.org/resource/image/75/97/7504f4738db767caa71a1f43a6bc8797.png" alt="">
        </div>
        <div class="partner-block">
          <div class="partner-block-title">指导单位</div>
          <ul class="partner-blocks">
            <li class="long-icon">
              <img src="https://static001.geekbang.org/resource/image/f7/0f/f7325e713bf8dab68ea7b50940677f0f.jpg" alt="">
            </li>
            <li class="long-icon">
              <img src="https://static001.geekbang.org/resource/image/45/d5/455f2e91fb2b5d5c45e94a42cd028bd5.jpg" alt="">
            </li>
          </ul>
        </div>
        <div class="partner-block">
          <div class="partner-block-title">学术指导单位</div>
          <ul class="partner-blocks">
            <li class="long-icon">
              <img src="https://static001.geekbang.org/resource/image/ee/32/eeeb90eac33a18cf40b2051e9f638432.jpg" alt="">
            </li>
          </ul>
        </div>
        <div class="partner-block">
          <div class="partner-block-title">主办方</div>
          <ul class="partner-blocks">
            <li class="long-icon">
              <img src="https://static001.geekbang.org/resource/image/8f/2f/8f458799bd1048c7218a23b780ed602f.jpg" alt="">
            </li>
            <li class="long-icon">
              <img src="https://static001.geekbang.org/resource/image/44/ce/443dda8fdc499d906545d958f2c756ce.jpg" alt="">
            </li>
          </ul>
        </div>
        <div class="partner-block">
          <div class="partner-block-title">赞助方</div>
          <ul class="partner-blocks">
            <li class="long-icon">
              <img src="https://static001.geekbang.org/resource/image/17/51/17dff35c79c4219621865f477481b951.jpg" alt="">
            </li>
          </ul>
        </div>
        <div class="partner-block">
          <div class="partner-block-title">战略合作伙伴</div>
          <ul class="partner-blocks">
            <li class="long-icon">
              <img src="https://static001.geekbang.org/resource/image/20/d2/20b92f8dfb46baa467d0d6b25f8357d2.jpg" alt="">
            </li>
          </ul>
        </div>
        <div class="partner-block">
          <div class="partner-block-title">协办方</div>
          <ul class="partner-blocks">
            <li class="long-icon">
              <img src="https://static001.geekbang.org/resource/image/b5/06/b537cf6ac1d609e5af1e96e05a707706.jpg" alt="">
            </li>
          </ul>
        </div>
        <div class="partner-block">
          <div class="partner-block-title">战略媒体</div>
          <ul class="partner-blocks-s" >
            <li class="short-icon"
              v-for="(item, index) in data.partner.media1"
              :key="index">
              <img :src="item" alt="">
            </li>
          </ul>
        </div>
        <div class="partner-block">
          <div class="partner-block-title">媒体支持</div>
          <ul class="partner-blocks-s" >
            <li class="short-icon"
              v-for="(item, index) in data.partner.media2 "
              :key="index"
              >
              <img :src="item" alt="">
            </li>
          </ul>
        </div>
      </div>
      <div class="block-line">
        <div class="block-line-left"></div>
        <img src="https://static001.geekbang.org/resource/image/f4/23/f4101ff41e7c0a04123bd7c2fc6c3823.png" alt="">
        <div class="block-line-right"></div>
      </div>
      <!-- 关于金链盟 -->
      <div id="about" class="about">
        <div class="block-title">
          <img src="https://static001.geekbang.org/resource/image/72/86/721cac1e31cc87a02fe9963345c50286.png" alt="">
          <span>关于金链盟</span>
          <img src="https://static001.geekbang.org/resource/image/75/97/7504f4738db767caa71a1f43a6bc8797.png" alt="">
        </div>
        <div class="about-block">
          <!-- <img src="https://static001.geekbang.org/resource/image/b2/f7/b27bc112252426fbeca48e52096090f7.png" alt=""> -->
          <p class="info">
            2016年5月31日，金融区块链合作联盟（深圳）（简称“金链盟”）由深圳市金融科技协会等二十余家金融机构和科技企业共同发起成立。金链盟作为一个开放式组织，自愿遵守章程的金融机构及向金融机构提供科技服务的企业等均可申请加入。至今，金链盟成员已涵括银行、基金、证券、保险、地方股权交易所、科技公司等六大类行业的100余家机构。<br>
            金链盟旨在整合及协调金融区块链技术研究资源，形成金融区块链技术研究和应用研究的合力与协调机制，提高成员单位在区块链技术领域的研发能力，探索、研发、实现适用于金融机构的金融联盟区块链，以及在此基础之上的应用场景。
          </p>
        </div>
        <div class="learnmore btnHover"><div class="hoverbox"></div>
          <a href="https://www.fisco.com.cn/index.html" target="_blank">点击进入金链盟官网</a>
        </div>
      </div>
      <!-- 移动端/大赛小助手 -->
      <div class="helper-mobile-target" id="helper-mobile-target">
        <img src="https://static001.geekbang.org/resource/image/0b/c3/0b732aeaf2e8a849c97b0ee8062782c3.jpeg" alt="">
        <span>大赛小助手</span>
      </div>  
    </div>
  </div>
</div>
</template>

<script>
  // import axios from 'axios'
  // import data from './data'
  // import NavInfoq from '@/components/navinfoq'
  import GiNav from '@/components/nav'
  import subloop from '@/components/subloop'
  // import GiTitle from '@/components/title'
  // import GiCard from '@/components/card'
  // import GiCard2 from '@/components/card2'
  // import editor from '@/components/editor'
  // import download from './vender/download'
  // import temp from './temp'
  // import Scheduleb from './scheduleb'
  import videojs from 'video.js'
  import 'videojs-contrib-hls'
  export default {
    components: {
      GiNav,
      subloop
    },
    data () {
      return {
        isBegin: false,
        isPc: true,
        isAndroid: false,
        isPhone: false,
        modalShow: false,
        top30: {
          line1: [
            {
              project: 'Boogie Consortium',
              content: '区块链街舞社区平台，将社区内的厂牌、工作室、活动组织方等机构的相关信息上链，用户活动可产生积分用于社区内部使用，实现街舞活动数据存证、锚定、智能合约签署等功能。',
              name: 'Boogie',
              show: true
            },
            {
              project: '第一反应互助急救',
              content: '区块链互助急救平台，将公益行为数据及公益人相关证书上链并转换为公益积分，同时联盟企业之间形成价值互联和资源共享，实现链上公益积分的流转。',
              name: '救要救信息科技',
              show: false
            },
            {
              project: '书享校园',
              content: '区块链图书漂流系统，学生和学生之间可以通过区块链Dapp进行书籍查询、借阅、归还等相关活动，经过学院间及学校间的节点共识，持久化存储在区块链上。',
              name: '华中科技大学',
              show: false
            },
            {
              project: '物联网可信互联解决方案',
              content: '区块链智能家居管理平台，实现智能设备的灵活访问控制，云端、管理端和智能终端间建立并维持可信连接、可靠权限管理、可审计可追溯的数据及用户隐私保护。',
              name: '四川长虹电器',
              show: false,
              compress: true
            },
            {
              project: '跨层全栈区块链安全检测',
              content: '区块链安全检测应用，针对区块链应用层、系统层、基础设施层代码质量安全问题，建立基于模糊测试方法的面向区块链全生命周期的跨层次多维度的安全保障系统。',
              name: '清华大学软件学院',
              show: false,
              compress: true
            }
          ],
          line2: [
            {
              project: '智慧城市服务平台',
              content: '智慧城市区块链服务平台，包括政务考核信息上链，保持政务系统公开透明；同时将征信办审核、复审、修正后的自然人及法人社会信用考核数据上链，促进社会信用体系建设。',
              name: '山东观海数据',
              show: false
            },
            {
              project: '银行间报价平台',
              content: '整合银行间债券二级市场报价业务、可嵌入各银行系统的区块链Dapp，进而实现报价实时化、透明化、可追溯，并引入监管节点达成穿透式监管目标。',
              name: '第一创业证券',
              show: false
            },
            {
              project: 'HaveFund',
              content: '来自日本的参赛项目，通过联盟链技术让日本地区的借款人和放款人智能匹配及借贷信息的上链存证形成共享账本；并利用区块链加密技术保证了放款公司和借款人的信息隐私。',
              name: 'MY Innovate（日本）',
              show: false
            },
            {
              project: '公益捐赠项目',
              content: '区块链慈善捐赠平台，利用区块链技术的公开透明、不可篡改、可追溯特性，灵活接入C端用户及不同的慈善机构或审计机构，追踪善款流转，项目已和厦门慈善总会合作。',
              name: '厦门国际银行',
              show: false
            },
            {
              project: '区块链票据交易系统',
              content: '区块链票据上链解决传统票据场景中流通不便、信息不对称等痛点，通过智能合约+监管账户实现交易撮合自动化并对企业进行征信评级。',
              name: '中票通',
              show: false
            }
          ],
          line3: [
            {
              project: '八戒保全',
              content: '区块链电子数据保全平台，综合公证、鉴定、法律、版权保护等相关组织数据上链。平台通过全证据链存证，固化电子证据，支持原文存证、哈希存证。',
              name: '重庆猪八戒网络有限公司',
              show: false
            },
            {
              project: '金融信用数据平台',
              content: '区块链信用数据共享平台，联合22家已成立持牌消费金融公司，组成信用数据共享联盟链，通过黑名单等业务数据共享，实现对风险评估提供参考。',
              name: '河北幸福消费金融',
              show: false
            },
            {
              project: '政府采购信用管理系统',
              content: '区块链诚信信息管理平台，主要在政府采购过程中已有的评价体系之上，利用区块链实现省级信用库、财政部信用库的互联互通，进而实现全国共享的行业联合惩戒。',
              name: '博思软件',
              show: false
            },
            {
              project: 'R-link',
              content: '区块链学历登记认证服务，通过校企合作将用户信息定期记录和维护，同时对链上数据上传和操作进行权限控制，实现个人简历信息的真实性、不可篡改性、不可伪造性。',
              name: '中国科学院深圳先进技术研究院',
              show: false
            },
            {
              project: '旅游金融联盟平台',
              content: '实现多个银行间旅游产品资源共享的区块链平台，通过将旅游产品、金融产品、客户及商户信息上链共享和管理，提升整体的客户服务能力。',
              name: '优讯',
              show: false
            }
          ],
          line4: [
            {
              project: 'ODRChain',
              content: '通过联盟链多链并行、跨链路由的架构设计，实现在多个城市（北广深南京等各地）组建司法联盟链，连接各个司法机构和企事业单位等，提供一站式综合法律服务。',
              name: '亦笔科技',
              show: false
            },
            {
              project: 'SCC智能合约安全检测',
              content: '智能合约安全检测应用，利用多维安全审计技术对Solidity智能合约进行安全性、正确性检测，并提供认证报告、一键部署上链的功能，实现合约生命周期管理。',
              name: '西安好码',
              show: false
            },
            {
              project: '乐寻坊人才活动平台',
              content: '区块链人才服务平台，与企业及社团合作，以联盟链形式实现互动激励，为人才活动、数据权益自主交换、学习培训记录认证、职业发展价值提升提供服务。',
              name: '乐寻坊',
              show: false
            },
            {
              project: '不动产登记平台',
              content: '区块链不动产登记信息平台，通过信息上链、多方共享和实时汇交，实现跨法、税、公安、民政等部门数据共享，提升交易、出租等环节的效率，同时保障数据安全。',
              name: '链动时代',
              show: false
            },
            {
              project: '飞企链',
              content: '区块链农资供应链金融平台，依托48家农资上市公司及厂家，通过农资供应链各方数据上链，实现交易数据验真及供应链主体业务流程公开、信息证明公示，提升资金周转效率。',
              name: '时代农信',
              show: false
            }
          ],
          line5: [
            {
              project: '医药供应链平台',
              content: '医药采购供应链金融平台，用区块链技术实现从物流端和资金流端的数据透明和不可篡改。提高医药行业上下游企业之间的协同能力和效率、减少供应链上下游的资金周转时间。',
              name: '中国人寿国寿投资',
              show: false
            },
            {
              project: '版权保管箱',
              content: '应用于版权领域的区块链版权保管箱，是集版权确权存证、交易备案、监测维权于一体的完整商用版权服务平台。',
              name: '北京版全家',
              show: false
            },
            {
              project: '“云块”账户系统',
              content: '区块链的基础设施，打造一套针对C端用户的账户系统（中间件），包含实名认证、用户信息授权与共享等功能，重点面向金融行业，实现企业级服务的区块链应用落地。',
              name: '云块项目团队',
              show: false
            },
            {
              project: '信链',
              content: '应用区块链技术，在区域性股权市场实现挂牌企业和债券信息披露生命全周期管理，建立信息共享平台及搭建参与者之间的新型交互关系，降低市场风险,促进市场繁荣。',
              name: '致远速联',
              show: false
            },
            {
              project: 'PCB透明工厂',
              content: '区块链在智能制造中的应用，将PCB工厂的状态、生产和经营数据上链多机构共享，完成准确的产品溯源和高效的供应链融资，提升制造业协作效率、品牌信誉和融资效率。',
              name: '基石数据',
              show: false
            }
          ],
          line6: [
            {
              project: '畜牧业区块链溯源',
              content: '区块链智慧养殖溯源平台，通过NB-IoT网络采集畜牧生命体征数据，实时存证上链，建立完整的电子档案，并实现保险保单通过智能合约实现线上签约、流转。',
              name: '全链通',
              show: false
            },
            {
              project: '可信电子固证平台',
              content: '区块链存证固证平台，通过“电子认证+区块链”的技术结合，集多方电子认证、存证、鉴证、取证等功能于一体，打通存证司法通道，提高司法取证效率，降低存证用户维权成本。',
              name: '深圳市电子商务安全证书管理有限公司',
              show: false
            },
            {
              project: 'JustSign',
              content: '区块链电子缔约与存证系统，独创JustKey白盒密码算法实现“手机即U盾”，保证电子合同签名的唯一性和签名人的确定性，实现可信电子合同区块链存证。',
              name: '云之道 & 四方精创',
              show: false
            },
            {
              project: '区块链保单管理',
              content: '基于区块链服务，将保险产品的保单信息和保单价值变化信息上链，并通过“前海人寿APP”能直观了解保单现价的变化轨迹，为机构间通过联盟链实现保单转移打下基础。',
              name: '前海人寿',
              show: false
            },
            {
              project: '蜂车链',
              content: '交通事故处理平台，打通汽车维修服务链条。用联盟链方式改善各参与机构的信任机制，以更低社会总成本的方案来处理私家车车主的轻微小事故痛点，也可作为车险投保的参考。',
              name: '亚来科技',
              show: false
            }
          ]
        },
        top10: {
          TOP: {
            project: 'ODRChain',
            content: '通过联盟链多链并行、跨链路由的架构设计，实现在多个城市（北广深南京等各地）组建司法联盟链，连接各个司法机构和企事业单位等，提供一站式综合法律服务。',
            name: '亦笔科技',
            cover: 'https://static001.geekbang.org/resource/image/79/78/797d3ecace6590bfb12bfa56ec7d9f78.jpg'
          },
          ONE: {
            project: 'JustSign',
            content: '区块链电子缔约与存证系统，独创JustKey白盒密码算法实现“手机即U盾”，保证电子合同签名的唯一性和签名人的确定性，实现可信电子合同区块链存证。',
            name: '云之道 & 四方精创',
            cover: 'https://static001.geekbang.org/resource/image/d8/7c/d83d7c22773e4292a49039addd76207c.jpg'
          },
          TWO: {
            project: '物联网可信互联解决方案',
            content: '区块链智能家居管理平台，实现智能设备的灵活访问控制，云端、管理端和智能终端间建立并维持可信连接、可靠权限管理、可审计可追溯的数据及用户隐私保护。',
            name: '四川长虹安全实验室',
            cover: 'https://static001.geekbang.org/resource/image/a7/5e/a7f803ca79f1a40d917ef4a2f8f9d45e.jpg'
          },
          THREE: [
            {
              project: '旅游金融联盟平台',
              content: '实现多个银行间旅游产品资源共享的区块链平台，通过将旅游产品、金融产品、客户及商户信息上链共享和管理，提升整体的客户服务能力。',
              name: '优讯',
              cover: 'https://static001.geekbang.org/resource/image/49/42/495d7582071554df947e651ce436d642.jpg'
            },
            {
              project: '不动产登记平台',
              content: '区块链不动产登记信息平台，通过信息上链、多方共享和实时汇交，实现跨法、税、公安、民政等部门数据共享，提升交易、出租等环节的效率，同时保障数据安全。',
              name: '链动时代',
              cover: 'https://static001.geekbang.org/resource/image/92/6b/923e2e2a93c58017462c53969e85976b.jpg'
            },
            {
              project: '智慧城市服务平台',
              content: '智慧城市区块链服务平台，包括政务考核信息上链，保持政务系统公开透明；同时将征信办审核、复审、修正后的自然人及法人社会信用考核数据上链，促进社会信用体系建设。',
              name: '山东观海数据',
              cover: 'https://static001.geekbang.org/resource/image/46/23/46a9848dbc0adb9e0fea493f40a26923.jpg'
            },
            {
              project: '版权保管箱',
              content: '应用于版权领域的区块链版权保管箱，是集版权确权存证、交易备案、监测维权于一体的完整商用版权服务平台。',
              name: '北京版全家',
              cover: 'https://static001.geekbang.org/resource/image/d9/10/d931de3d93de45798a489868930c7510.jpg'
            },
            {
              project: '畜牧业区块链溯源',
              content: '区块链智慧养殖溯源平台，通过NB-IoT网络采集畜牧生命体征数据，实时存证上链，建立完整的电子档案，并实现保险保单通过智能合约实现线上签约、流转。',
              name: '全链通',
              cover: 'https://static001.geekbang.org/resource/image/6a/20/6a0bb19df3bbc6d470980f369b76cb20.jpg'
            },
            {
              project: '可信电子固证平台',
              content: '区块链存证固证平台，通过“电子认证+区块链”的技术结合，集多方电子认证、存证、鉴证、取证等功能于一体，打通存证司法通道，提高司法取证效率，降低存证用户维权成本。',
              name: '深圳市电子商务安全证书管理有限公司',
              cover: 'https://static001.geekbang.org/resource/image/7b/4f/7be2f9cd14939ff0539cdf86b5f5a84f.jpg'
            },
            {
              project: '跨层全栈区块链安全检测',
              content: '区块链安全检测应用，针对区块链应用层、系统层、基础设施层代码质量安全问题，建立基于模糊测试方法的面向区块链全生命周期的跨层次多维度的安全保障系统。',
              name: '清华大学软件学院',
              cover: 'https://static001.geekbang.org/resource/image/49/81/49529a0847d812f92567f75054d77a81.jpg'
            }
          ],
          subAward: [
            {
              awardName: '优秀社会价值奖',
              project: '第一反应互助急救',
              content: '区块链互助急救平台，将公益行为数据及公益人相关证书上链并转换为公益积分，同时联盟企业之间形成价值互联和资源共享，实现链上公益积分的流转。',
              name: '救要救信息科技',
              cover: 'https://static001.geekbang.org/resource/image/9f/d5/9fc450f2a558375ed809558e375a23d5.jpg'
            },
            {
              awardName: '优秀商业设计奖',
              project: 'HaveFund',
              content: '来自日本公司的参赛项目，通过联盟链技术让日本地区的借款人和放款人智能匹配及借贷信息的上链存证形成共享账本；并利用区块链加密技术保证了放款公司和借款人的信息隐私。',
              name: 'MY Innovate（日本）',
              cover: 'https://static001.geekbang.org/resource/image/64/70/646a1f7ad5ad1b3dd646eed2798b7b70.jpg'
            },
            {
              awardName: '优秀用户价值奖',
              project: '区块链保单管理',
              content: '基于区块链服务，将保险产品的保单信息和保单价值变化信息上链，并通过“前海人寿APP”能直观了解保单现价的变化轨迹，为机构间通过联盟链实现保单转移打下基础。',
              name: '前海人寿',
              cover: 'https://static001.geekbang.org/resource/image/56/9a/569dd3895cfbf7f970d1300064c7869a.jpg'
            },
            {
              awardName: '优秀创意奖',
              project: '书享校园',
              content: '区块链图书漂流系统，学生和学生之间可以通过区块链Dapp进行书籍查询、借阅、归还等相关活动，经过学院间及学校间的节点共识，持久化存储在区块链上。',
              name: '华中科技大学',
              cover: 'https://static001.geekbang.org/resource/image/2c/c1/2cc8291210a1efa6ab82fd4a69d4e5c1.jpg'
            },
            {
              awardName: '优秀应用融合奖',
              project: '“云块”账户系统',
              content: '区块链的基础设施，打造一套针对C端用户的账户系统（中间件），包含实名认证、用户信息授权与共享等功能，重点面向金融行业，实现企业级服务的区块链应用落地。',
              name: '云块项目团队',
              cover: 'https://static001.geekbang.org/resource/image/68/d2/687843ee3b2673cb3ab17692c55c9cd2.jpg'
            }
          ]
        },
        navtab: 0,
        showTab: 1,
        judgeShow: -1,
        docsHover: false,
        navBarFixed: false,
        data: {
          'loogimg1': 'https://static001.geekbang.org/resource/image/20/d2/20b92f8dfb46baa467d0d6b25f8357d2.jpg',
          'logo': {
            'img': 'https://static001.geekbang.org/resource/image/66/2e/6683c714fbc4b84b5524dd2b9efc572e.png'
          },
          '导航栏': {
            'list': [
              {
                'name': '大赛介绍',
                'link': '#',
                '是否显示': true
              },
              {
                'name': '赛事动态',
                'link': '#status',
                '是否显示': true
              },
              {
                'name': '参赛权益',
                'link': '#rights',
                '是否显示': true
              },
              {
                'name': '大赛奖项',
                'link': '#awards',
                '是否显示': true
              },
              {
                'name': '专家评委',
                'link': '#judge',
                '是否显示': true
              },
              {
                'name': '赛程安排',
                'link': '#schedule',
                '是否显示': true
              },
              {
                'name': '评审规则',
                'link': '#rulers',
                '是否显示': true
              },
              {
                'name': '参赛须知',
                'link': '#notify',
                '是否显示': true
              },
              {
                'name': '合作单位',
                'link': '#partner',
                '是否显示': true
              },
              {
                'name': '技术文档',
                'link': 'https://github.com/FISCO-BCOS/FISCO-BCOS/wiki',
                '是否显示': true
              }
            ]
          },
          nav: [
            {text: '大赛介绍', link: '#'},
            {text: '赛事动态', link: '#status'},
            {text: '参赛权益', link: '#rights'},
            {text: '大赛奖项', link: '#awards'},
            {text: '专家评委', link: '#judge'},
            {text: '赛程安排', link: '#schedule'},
            {text: '评审规则', link: '#rulers'},
            {text: '参赛须知', link: '#notify'},
            {text: '合作单位', link: '#partner'}
          ],
          judge: [
            {
              name: '陈 亮',
              avatar: 'https://static001.geekbang.org/resource/image/3d/7e/3d334fdea897bd408ba65cc1b6a0857e.png',
              tags: ['中钞区块链技术研究院', '产品总监']
            },
            {
              name: '范瑞彬',
              avatar: 'https://static001.geekbang.org/resource/image/37/1c/373938e24f5bfa7a16b9952e8d144b1c.png',
              tags: ['金链盟开源工作组组长']
            },
            {
              name: '焦 松',
              avatar: 'https://static001.geekbang.org/resource/image/62/7b/62f5b24273662b333648fc611f62c17b.png',
              tags: ['深圳市创新投资集团有限公司高级研究员', '中国互联网协会青年专家']
            },
            {
              name: '毛崇岗',
              avatar: 'https://static001.geekbang.org/resource/image/1f/f0/1f5a037e01fd1e54776889f94c9b86f0.png',
              tags: ['招商证券金融科技创新办主任', '粤港澳合作促进会金融专业委员']
            },
            {
              name: '邵 兵',
              avatar: 'https://static001.geekbang.org/resource/image/90/33/90328e97849019dfaa05db2cfaf1f533.png',
              tags: ['腾讯云区块链首席产品经理']
            },
            {
              name: '孙毅',
              avatar: 'https://static001.geekbang.org/resource/image/70/cc/706adcb86458a2c9ed9b43f84c52cbcc.png',
              tags: ['中国计算机学会区块链专委会副主任', '中科院计算所博导']
            },
            {
              name: '斯雪明',
              avatar: 'https://static001.geekbang.org/resource/image/c6/b5/c6be1977cb3a681e85f1828f68a382b5.png',
              tags: ['复旦大学教授', '中国计算机学会区块链专委会主任']
            },
            {
              name: '宿旭升',
              avatar: 'https://static001.geekbang.org/resource/image/cc/7b/cc34b6d6b3d2001af2af4546530d827b.png',
              tags: ['金链盟副秘书长']
            },
            {
              name: '肖鸿达',
              avatar: 'https://static001.geekbang.org/resource/image/2a/44/2a5562e8f14467a45ecec78d0392a244.png',
              tags: ['腾讯投资高级投资经理']
            },
            {
              name: '张 凯',
              avatar: 'https://static001.geekbang.org/resource/image/1f/aa/1fced50091ff793e297a730cc04954aa.png',
              tags: ['深圳大学深圳南特商学院中方院长', '深大-微众金融科技研究院院长']
            },
            {
              name: '周平',
              avatar: 'https://static001.geekbang.org/resource/image/84/05/84b66fb86c0556d4a70bc4a8c22cca05.png',
              tags: ['工业和信息化部电子标准院', '软件工程与评估中心主任']
            },
            {
              name: '张开翔',
              avatar: 'https://static001.geekbang.org/resource/image/84/fb/84081b3af7c6d52f2cc9018d6e172cfb.png',
              tags: ['微众银行区块链首席架构师 ']
            },
            {
              name: '张一锋',
              avatar: 'https://static001.geekbang.org/resource/image/2c/9a/2c79f145c4c569089cc7d6f34fde2a9a.png',
              tags: ['中钞区块链技术研究院院长']
            }
          ],
          partner: {
            media1: [
              'https://static001.geekbang.org/resource/image/6f/81/6f0d9e80c7fc738e170180cef36add81.jpg',
              'https://static001.geekbang.org/resource/image/54/4c/540a7fa76feed1e1abefc58db1d49b4c.jpg',
              'https://static001.geekbang.org/resource/image/d5/77/d533210e4a097b1dce43da4271ed2a77.jpg',
              'https://static001.geekbang.org/resource/image/ac/79/ace7dcdd91ea463064640dd576764679.jpg',
              'https://static001.geekbang.org/resource/image/4d/20/4d09136fddd781fd3ad7191ccb24d420.jpg',
              'https://static001.geekbang.org/resource/image/f8/42/f85a69c5cc57b48ab054e8f84bf02142.jpg',
              'https://static001.geekbang.org/resource/image/97/c5/97c4aaa47da547884aa85650548134c5.jpg',
              'https://static001.geekbang.org/resource/image/87/c3/87c20d644923d3c40fe92101cd0dc6c3.jpg',
              'https://static001.geekbang.org/resource/image/8b/19/8bee818d5fb1744883804d260c771019.jpg',
              'https://static001.geekbang.org/resource/image/4f/f0/4f01e182102f99448b8a8b9c16ed7ff0.jpg',
              'https://static001-test.geekbang.org/resource/image/2b/9c/2b3ffa8495109534635771ce40ddad9c.jpg',
              'https://static001.geekbang.org/resource/image/20/62/20d3d47cac7c4b53f011b68518c14962.jpg'
            ],
            media2: [
              'https://static001.geekbang.org/resource/image/56/6d/56a288e19b9bdc208fee081729d0686d.jpg',
              'https://static001.geekbang.org/resource/image/3e/45/3e7657435e54c0581317b94e0bf87d45.jpg',
              'https://static001.geekbang.org/resource/image/1b/5a/1b6aa1f9ba580572cce42595a5dccb5a.jpg',
              'https://static001.geekbang.org/resource/image/5d/2c/5def99e6a5999499bd9710416be0aa2c.jpg',
              'https://static001.geekbang.org/resource/image/70/03/700af2046000c408dc0c661de1e1d603.jpg',
              'https://static001.geekbang.org/resource/image/c3/d9/c3f4e6990a1c07a29457e37372cd3dd9.jpg',
              'https://static001-test.geekbang.org/resource/image/b6/e9/b666f86401538a3a8399aeba9161c2e9.jpg',
              'https://static001.geekbang.org/resource/image/9d/dc/9d2d404f405a59530605e4db5d6a53dc.jpg',
              'https://static001-test.geekbang.org/resource/image/9d/83/9d04bdb02c06b4be13441dbc57880f83.jpg',
              'https://static001.geekbang.org/resource/image/13/4f/138193946f55d811adee60af9630b44f.jpg',
              'https://static001.geekbang.org/resource/image/9c/41/9c6015c3f9091c544f1552ae44ba6d41.jpg',
              'https://static001.geekbang.org/resource/image/51/e6/51ac5c71bdedd57cc757bd66d3f73de6.jpg',
              'https://static001.geekbang.org/resource/image/a5/8e/a597e4000119f6eca8c0cbbb11b64f8e.jpg',
              'https://static001.geekbang.org/resource/image/b7/74/b77908bae05afaac66d4d77d92a48974.jpg',
              'https://static001.geekbang.org/resource/image/64/bb/642de029a48b2d92f9a45ed0cd4d2dbb.jpg',
              'https://static001.geekbang.org/resource/image/92/15/92bbdc94f28da0018db6ca0be9122315.jpg',
              'https://static001.geekbang.org/resource/image/60/41/60c8b74e7e60bf1c5517a91360069a41.jpg',
              'https://static001.geekbang.org/resource/image/65/c1/659606e704c20763b34974d479781dc1.jpg',
              'https://static001.geekbang.org/resource/image/03/56/03079738ddd108acad91e9324f0ef856.jpg',
              'https://static001.geekbang.org/resource/image/98/c9/98eb6eb9524b338f2a70fd5bc578d6c9.jpg',
              'https://static001.geekbang.org/resource/image/00/2f/005ab19480f2ad47b151006ecf3bef2f.jpg',
              'https://static001.geekbang.org/resource/image/d8/63/d850cd5ea930b694146748999c68ae63.jpg',
              'https://static001-test.geekbang.org/resource/image/dc/b5/dc25bd046ffe482a0e87d7c6ea4d4fb5.jpg',
              'https://static001-test.geekbang.org/resource/image/0b/a1/0b81a956f2d069c16ab315cdac33a0a1.jpg',
              'https://static001.geekbang.org/resource/image/fb/1e/fba4d6d9b16ee4e7d4af2773fd9c8f1e.jpg'
            ]
          }
        }
      }
    },
    computed: {
      top30Mobile () {
        return [...this.top30.line1, ...this.top30.line2, ...this.top30.line3, ...this.top30.line4, ...this.top30.line5, ...this.top30.line6]
      }
    },
    created () {
      this.pageInit()
    },
    mounted () {
      window.addEventListener('scroll', this.watchScroll) // 事件监听滚动条
      videojs('pcvideo', {
        bigPlayButton: false,
        textTrackDisplay: false,
        posterImage: true,
        errorDisplay: false,
        controlBar: true
      }, function () {
        console.log('init')
      })
    },
    methods: {
      videoPlay () {
        this.modalShow = true
        var myplayer = videojs('pcvideo')
        myplayer.ready(function () {
          this.play()
        })
        document.querySelector("html").classList.add("lock")
      },
      closeModal () {
        this.modalShow = false
        document.querySelector("html").classList.remove("lock")
        var myplayer = videojs('pcvideo')
        myplayer.pause()
      },
      FullScreen () {
        var ele = document.documentElement;
        if (ele.requestFullscreen) {
          ele.requestFullscreen();
        } else if (ele.mozRequestFullScreen) {
          ele.mozRequestFullScreen();
        } else if (ele.webkitRequestFullScreen) {
          ele.webkitRequestFullScreen();
        }
      },
      pageInit () {
        var os = function() {
          var ua = navigator.userAgent,
          isWindowsPhone = /(?:Windows Phone)/.test(ua),
          isSymbian = /(?:SymbianOS)/.test(ua) || isWindowsPhone, 
          isAndroid = /(?:Android)/.test(ua), 
          isFireFox = /(?:Firefox)/.test(ua), 
          isChrome = /(?:Chrome|CriOS)/.test(ua),
          isTablet = /(?:iPad|PlayBook)/.test(ua) || (isAndroid && !/(?:Mobile)/.test(ua)) || (isFireFox && /(?:Tablet)/.test(ua)),
          isPhone = /(?:iPhone)/.test(ua) && !isTablet,
          isPc = !isPhone && !isAndroid && !isSymbian;
          return {
            isTablet: isTablet,
            isPhone: isPhone,
            isAndroid : isAndroid,
            isPc : isPc
          };
        }()
        this.isPc = (os.isAndroid || os.isPhone) ? false : true
        this.isAndroid = os.isAndroid ? true : false
        this.isPhone = os.isPhone ? true : false
      },
      navHover (order) {
        this.navtab = Number(order)
      },
      navDocHoverFn () {
        this.docsHover = true
      },
      navDocOutFn () {
        this.docsHover = false
      },
      judgeHover (order) {
        this.judgeShow = order
      },
      judgeOut () {
        this.judgeShow = -1
      },
      overshow (order) {
        this.showTab = Number(order)
      },
      watchScroll () {
        var scrollTop = window.pageYOffset || document.documentElement.scrollTop || document.body.scrollTop
        if (scrollTop > 0) {
          this.navBarFixed = true
        } else {
          this.navBarFixed = false
        }
      },
      // top30
      top30Show (index) { // toggle 30 强信息
        this.top30Mobile.forEach((item, i) => {
          if (index === i) {
            item.show = !item.show
          }
        })
      }
    }
  }
</script>

<style lang="sass">
.el-dialog
  background-color: transparent !important
.videoinner
  width: 100%
  height: 100%
@import "./App.sass"
.height40
  height: 41% !important
.height50
  height: 51% !important
.height60
  height: 60% !important
.height70
  height: 70% !important
.height80
  height: 80% !important
.height90
  height: 90% !important
.height100
  height: 100% !important
.width40
  width: 41% !important
.width50
  width: 51% !important
.width60
  width: 60% !important
.width70
  width: 70% !important
.width80
  width: 80% !important
.width90
  width: 90% !important
.width100
  width: 100% !important
.pc-block
  border: solid 2px #dd242a !important
  box-shadow: 0 0 15px #df2429 !important
  background: linear-gradient(to top, #dd242a, transparent) !important
.m-block
  border: solid 1px #df2429 !important
  box-shadow: 0 0 15px #df2429 !important
  background: linear-gradient(to bottom, #3b0b5d, #a91c3a) !important
.compress
  letter-spacing: -1px


.videoBox
  width: 100vw
  height: 100vh
  background-color: rgba(0,0,0,0.4)
  position: fixed
  top: 0
  left: 0
  z-index: 1000
  overflow-y: hidden
  .videoContent
    width: 80%
    height: 575px
    margin: 67px auto
    +mobile
      height: 170px
      margin: 46% auto
  .closeBtn
    width: 20px
    height: 20px
    position: absolute
    top: 10%
    right: 8%
    display: inline-block
    cursor: pointer
    +mobile
      top: 27%
      right: 3%
.boxHide
  height: 0
  overflow: hidden
.lock
  overflow: hidden;
  touch-action: none;
.lock body
  overflow: hidden;
  touch-action: none;
</style>



// WEBPACK FOOTER //
// src/App.vue